import { defineMessages } from 'react-intl';

export const pricingOverridesMessages = defineMessages({
    pricingOverrides: {
        id: 'pricing-overrides',
        defaultMessage: 'Price coefficients',
    },
    pricingOverride: {
        id: 'pricing-override',
        defaultMessage: 'price coefficient',
    },
    coefficient: {
        id: 'pricing-override-coefficient',
        defaultMessage: 'Coefficient',
    },
    coefficientHint: {
        id: 'pricing-override-coefficient-hint',
        defaultMessage: 'Multiplies the plan price. 5 means five times the base price; 0.5 means half of it.',
    },
    addPricingOverrideSubtitle: {
        id: 'add-pricing-override-subtitle',
        defaultMessage: 'Scale this item’s plan price for this subscription only. Invoices show the final price.',
    },
    editPricingOverrideSubtitle: {
        id: 'edit-pricing-override-subtitle',
        defaultMessage: 'Edit price coefficient',
    },
    createPricingOverrideSuccess: {
        id: 'create-pricing-override-success',
        defaultMessage: 'Price coefficient created',
    },
    createPricingOverrideSuccessDescription: {
        id: 'create-pricing-override-success-description',
        defaultMessage: 'The price coefficient has been successfully created.',
    },
    updatePricingOverrideSuccess: {
        id: 'update-pricing-override-success',
        defaultMessage: 'Price coefficient updated',
    },
    updatePricingOverrideSuccessDescription: {
        id: 'update-pricing-override-success-description',
        defaultMessage: 'The price coefficient has been successfully updated.',
    },
    deletePricingOverrideSuccess: {
        id: 'delete-pricing-override-success',
        defaultMessage: 'Price coefficient deleted',
    },
    deletePricingOverrideSuccessDescription: {
        id: 'delete-pricing-override-success-description',
        defaultMessage: 'The price coefficient has been successfully deleted.',
    },
    deletePricingOverride: {
        id: 'delete-pricing-override',
        defaultMessage: 'Delete price coefficient',
    },
    deletePricingOverrideSubtitle: {
        id: 'delete-pricing-override-subtitle',
        defaultMessage: 'This item will go back to the plan’s base price for the affected period.',
    },
    confirmDeletePricingOverride: {
        id: 'confirm-delete-pricing-override',
        defaultMessage: 'Are you sure you want to delete this price coefficient?',
    },
    currentCoefficient: {
        id: 'current-coefficient',
        defaultMessage: 'Coefficient',
    },
    noPricingOverrides: {
        id: 'no-pricing-overrides',
        defaultMessage: 'No price coefficients',
    },
    noPricingOverridesDescription: {
        id: 'no-pricing-overrides-description',
        defaultMessage: 'This item is billed at the plan’s base price.',
    },
});
